/** IE polyfills. */
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/string/includes';
import 'core-js/features/number/parse-float';
import 'core-js/features/number/parse-int';
